module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('refresh', {
    staticClass: "dof-refresher",
    attrs: {
      "display": _vm.refreshing ? 'show' : 'hide',
      "data-evt-refresh": "",
      "data-evt-pullingdown": ""
    },
    nativeOn: {
      "refresh": function($event) {
        $event.stopPropagation();
        return _vm.onRefresh($event)
      },
      "pullingdown": function($event) {
        $event.stopPropagation();
        return _vm.onPullingDown($event)
      }
    }
  }, [(_vm.refreshing) ? _c('midea-apng-view', {
    staticClass: "indicator",
    attrs: {
      "loop": true,
      "auto": true,
      "src": _vm.loadingIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.refresherText) ? _c('p', {
    staticClass: "u-txt weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.refresherText))]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-967e72fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-967e72fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-refresher/index.vue
// module id = 658
// module chunks = 0 1